/* Lounelle PDP — defer non-critical custom UI until it is close to the viewport. */
(function () {
  'use strict';

  var loader = document.currentScript || document.querySelector('script[data-lounelle-deferred-ui]');
  if (!loader || window.__LounelleDeferredUiReady) return;
  window.__LounelleDeferredUiReady = true;

  var ugcSrc = loader.getAttribute('data-ugc-src');
  var accordionSrc = loader.getAttribute('data-accordion-src');
  var loaded = Object.create(null);
  var loading = Object.create(null);

  function loadScript(key, src) {
    if (!src || loaded[key] || loading[key]) return;
    loading[key] = true;

    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.onload = function () {
      loaded[key] = true;
      loading[key] = false;
    };
    script.onerror = function () {
      loading[key] = false;
    };
    document.head.appendChild(script);
  }

  function firstMatch(selectors) {
    try { return document.querySelector(selectors); }
    catch (_) { return null; }
  }

  function loadNear(target, key, src, margin) {
    if (!target) return;

    if (!('IntersectionObserver' in window)) {
      loadScript(key, src);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (!entries[i].isIntersecting) continue;
        observer.disconnect();
        loadScript(key, src);
        break;
      }
    }, { rootMargin: margin || '1200px 0px', threshold: 0 });

    observer.observe(target);
  }

  function initReviewSummaryAnchor() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href="#judgeme_product_reviews"]');
      if (!link) return;

      var target =
        firstMatch('#judgeme_product_reviews .jdgm-rev-widg__summary') ||
        firstMatch('#judgeme_product_reviews .jdgm-rev-widg__header') ||
        firstMatch('#judgeme_product_reviews');

      if (!target) return;

      event.preventDefault();
      event.stopPropagation();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, true);
  }

  function initDesktopUgcDragGuard() {
    if (!window.matchMedia) return;

    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    var state = {
      root: null,
      pointerId: null,
      startX: 0,
      startY: 0,
      dragged: false,
      suppressUntil: 0
    };

    document.addEventListener('pointerdown', function (event) {
      if (!finePointer.matches || event.button !== 0) return;

      var rail = event.target.closest && event.target.closest('[data-lugc-rail]');
      var root = rail && rail.closest('[data-lugc-root]');
      if (!root) return;

      state.root = root;
      state.pointerId = event.pointerId;
      state.startX = event.clientX;
      state.startY = event.clientY;
      state.dragged = false;
      state.suppressUntil = 0;
    }, true);

    document.addEventListener('pointermove', function (event) {
      if (state.pointerId !== event.pointerId || state.dragged) return;

      var dx = event.clientX - state.startX;
      var dy = event.clientY - state.startY;
      if ((dx * dx) + (dy * dy) > 64) state.dragged = true;
    }, true);

    document.addEventListener('pointerup', function (event) {
      if (state.pointerId !== event.pointerId) return;
      if (state.dragged) state.suppressUntil = Date.now() + 350;
      state.pointerId = null;
    }, true);

    document.addEventListener('pointercancel', function (event) {
      if (state.pointerId !== event.pointerId) return;
      state.root = null;
      state.pointerId = null;
      state.dragged = false;
      state.suppressUntil = 0;
    }, true);

    document.addEventListener('click', function (event) {
      if (!finePointer.matches || Date.now() > state.suppressUntil) return;

      var button = event.target.closest && event.target.closest('[data-lugc-open]');
      var root = button && button.closest('[data-lugc-root]');
      if (!button || !root || root !== state.root) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      state.root = null;
      state.dragged = false;
      state.suppressUntil = 0;
    }, true);
  }

  function init() {
    var ugc = firstMatch('[data-lugc-root]');
    var accordions = firstMatch('.product-details-accordion, .product-fit-accordion, .product-shipping-accordion, .product__accordions[id^="Block--"], .product__features');

    loadNear(ugc, 'ugc', ugcSrc, '1400px 0px');
    loadNear(accordions, 'accordions', accordionSrc, '1400px 0px');
  }

  initReviewSummaryAnchor();
  initDesktopUgcDragGuard();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    if (!loaded.ugc && !loading.ugc) {
      var ugc = firstMatch('[data-lugc-root]');
      if (ugc) loadScript('ugc', ugcSrc);
    }
    if (!loaded.accordions && !loading.accordions) {
      var accordions = firstMatch('.product-details-accordion, .product-fit-accordion, .product-shipping-accordion, .product__accordions[id^="Block--"], .product__features');
      if (accordions) loadScript('accordions', accordionSrc);
    }
  });
})();
